import Grid from '@mui/material/Grid2';
import { TypographyBold, TypographyStepTitle } from '../style/typography';
import { RequestDetailButton } from "../style/button";
import { TypographyNomalBold } from '../style/typography';
import { SmallCell } from '../style/tablecell';
import { Edit } from '@mui/icons-material';
import { Box, TableContainer, Table, TableHead, TableBody, TableRow, Paper } from '@mui/material';
import CommonCard from '../components/common_card';

const ContactInfo = ({ onAssignClick, damWorkAssignList, powerplantWorkAssignList, isButtonDisabled }) => {
  return (
    <Grid container size={{ xs: 12 }} spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Grid container size={{ xs: 12 }}>
          <Grid size={{ xs: 6, sm: 8, md: 10 }}>
            <TypographyStepTitle sx={{ fontSize: { xs: "1.4rem", sm: "1.5rem", md: "1.5rem" } }}>
              担当者情報
            </TypographyStepTitle>
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }} display="flex" justifyContent="flex-end">
            {!isButtonDisabled && (
              <RequestDetailButton
                size="large"
                startIcon={<Edit />}
                onClick={onAssignClick}
                >
                招集/業務割当を開始する
              </RequestDetailButton>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 6 }}>
        <Grid size={{ xs: 8 }}>
          <TypographyBold sx={{ mb: 1 }}>ダム業務担当者一覧</TypographyBold>
        </Grid>
        <CommonCard
          child={
            <Box sx={{ boxSizing: 'border-box' }}>
              <TableContainer component={Paper} sx={{ maxHeight: 500, overflowX: "auto" }}>
                <Table stickyHeader sx={{ tableLayout: "auto", minWidth: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <SmallCell><TypographyNomalBold>業務名</TypographyNomalBold></SmallCell>
                      <SmallCell><TypographyNomalBold>担当者1</TypographyNomalBold></SmallCell>
                      <SmallCell><TypographyNomalBold>担当者2</TypographyNomalBold></SmallCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {damWorkAssignList.map((row, index) => (
                      <TableRow key={row.work_uuid}>
                        <SmallCell>{row.work_name ?? '-'}</SmallCell>
                        <SmallCell>{row.user_name01 ?? '-'}</SmallCell>
                        <SmallCell>{row.user_name02 ?? '-'}</SmallCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          }
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 6 }}>
        <Grid size={{ xs: 8 }}>
          <TypographyBold sx={{ mb: 1 }}>
            発電所業務担当者一覧
          </TypographyBold>
        </Grid>
        <CommonCard
          child={
            <Box sx={{ boxSizing: 'border-box' }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <SmallCell>
                        <TypographyNomalBold>
                          業務名
                        </TypographyNomalBold>
                      </SmallCell>
                      <SmallCell>
                        <TypographyNomalBold>
                          担当者1
                        </TypographyNomalBold>
                      </SmallCell>
                      <SmallCell>
                        <TypographyNomalBold>
                          担当者2
                        </TypographyNomalBold>
                      </SmallCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {powerplantWorkAssignList.map((row, index) => (
                      <TableRow key={row.work_uuid}>
                        <SmallCell>{row.work_name ?? '-'}</SmallCell>
                        <SmallCell>{row.user_name01 ?? '-'}</SmallCell>
                        <SmallCell>{row.user_name02 ?? '-'}</SmallCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          }
        />
      </Grid>
    </Grid>
  );
};

export default ContactInfo;